import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { TipoTemplate } from 'src/app/models/tipo-template';
import { TipoTemplateService } from 'src/app/services/tipo-template.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { TipiTemplateFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'tipi-template',
  templateUrl: './tipi-template.component.html',
  styleUrls: ['./tipi-template.component.scss']
})
export class TipiTemplateComponent implements OnInit {


  headingText: string = 'Tipi di template';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),

  ];
  constructor(public tipoTemplateService: TipoTemplateService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<TipiTemplateComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un tipo di template';
    }
  }
  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (tipoTemplate: TipoTemplate) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il tipo di template ${tipoTemplate.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.tipoTemplateService.delete(tipoTemplate);
          this.toast.success('Tipo di template eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione tipo di template fallita.", "Errore!");
    }
  }



  editFunction = async (tipoTemplate: TipoTemplate) => {
    try {
      let dialogRef = this.dialog.open(TipiTemplateFormComponent, { data: tipoTemplate });
      dialogRef.afterClosed().subscribe(async (data: TipoTemplate) => {
        if (data) {

          Object.assign(tipoTemplate, data);

          await this.tipoTemplateService.edit(tipoTemplate);

          this.toast.success('Tipo di template modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica tipo di template fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(TipiTemplateFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(tipoTemplate?: TipoTemplate) {
    if (tipoTemplate) {
      try {
        await this.tipoTemplateService.create(tipoTemplate)
        this.toast.success('Tipo di template creato!')
      }
      catch (e) {
        this.toast.error('Creazione tipo di template fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
